import {
  AccordionItem,
  Button,
  Flex,
  Input,
  InputGroup,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { UpDownOptionWithSelectValueProps } from 'components/atoms/form/inputList/upDownOptionWithSelect';
import { Career, Focus } from 'lib/generated/graphql';
import { useJobFilters } from 'lib/repositories/jobsShowcaseFilters';

interface Params {
  suggestFocus:
    | (Pick<Focus, 'id' | 'description'> & {
        career: Pick<Career, 'worksWithSkills'>;
      })[]
    | undefined;
  allFocuses: (Pick<Focus, 'id' | 'description'> & {
    career: Pick<Career, 'id' | 'name' | 'slug' | 'worksWithSkills'>;
  })[];
  notifyChange?: (focus: Focus) => void;
  selectedItems?: UpDownOptionWithSelectValueProps[];
  placeholder?: string;
}

const FocusItems = ({
  suggestFocus,
  allFocuses,
  selectedItems,
  placeholder = 'Digite para pesquisar',
  notifyChange,
}: Params) => {
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] = useState<Focus[]>([]);
  const { filters, setFocuses } = useJobFilters();

  const loadFromSuggestions = (excludeIds: string[]) => {
    setFilteredData(
      suggestFocus?.filter(
        (focus) => !excludeIds?.includes(focus.id)
      ) as Focus[]
    );
  };

  const loadFromFocus = (excludeIds: string[]) => {
    const parsedData = allFocuses.filter(
      (focus: { id: string; description: string }) =>
        focus.description.toLowerCase().includes(searchText) &&
        !excludeIds?.includes(focus.id)
    );
    setFilteredData(parsedData);
  };
  const handleItemsChange = () => {
    const excludeIds = notifyChange
      ? selectedItems?.map((focus) => focus.value) || []
      : filters?.focuses?.map((focus) => focus.id) || [];

    if (!searchText && suggestFocus) {
      loadFromSuggestions(excludeIds);
    } else {
      loadFromFocus(excludeIds);
    }
  };

  const onChange = (focus: Focus) => {
    if (notifyChange) {
      notifyChange(focus);
    } else {
      let parsedFilters = [];
      if (filters.focuses && filters.focuses.includes(focus)) {
        parsedFilters = filters.focuses.filter((f) => f.id !== focus.id);
      } else {
        parsedFilters = [...(filters.focuses ?? []), focus];
      }
      setFocuses(parsedFilters);
    }
  };

  useEffect(() => {
    handleItemsChange();
  }, [searchText, filters, selectedItems]);

  return (
    <>
      <InputGroup flexDirection='column' marginTop={-2}>
        <Input
          data-testid='input'
          aria-label='Pesquisar'
          placeholder={placeholder}
          height={10}
          width='100%'
          type='text'
          name='focusSearch'
          onChange={(e) => setSearchText(e.currentTarget.value)}
          value={searchText}
          border={0}
          fontWeight='400'
          fontSize='14px'
          _focus={{
            outline: 'none',
          }}
        />
        <div style={{ paddingLeft: 5, paddingRight: 5, marginBottom: 5 }}>
          <hr />
        </div>
      </InputGroup>
      {filteredData?.length === 0 ? (
        <Flex alignItems='center' justifyContent='center' color='text.200'>
          Nenhum resultado encontrado{' '}
        </Flex>
      ) : (
        filteredData.map((focus) => (
          <AccordionItem key={focus.id} border='none'>
            <Button
              data-testid={`asyncSelectFocus-${focus.id}`}
              width='100%'
              sx={{
                backgroundColor: 'white',
              }}
              px={2}
              fontSize='sm'
              key={focus.id}
              display='flex'
              alignItems='center'
              justifyContent='normal'
              _hover={{
                bgColor: 'primary.150',
              }}
              _focus={{
                boxShadow: 'none',
              }}
              onClick={() => onChange(focus)}
            >
              {focus.description}
            </Button>
          </AccordionItem>
        ))
      )}
    </>
  );
};
export default FocusItems;
